import { useEffect, useRef } from "react";
import * as api from "../api";

// Notion al abrir «Tareas»: si la persona tiene Notion conectado y lleva mas de 4 h sin sincronizar, el servidor lo
// sincroniza EN SEGUNDO PLANO (POST /mis-tareas/notion/al-dia responde al instante). La lista ya ha salido con lo que habia;
// aqui se vuelve a pedir mientras dura (el servidor dice `notion.sincronizando`) y una vez mas al terminar, para que las tareas
// de Notion aparezcan actualizadas sin que la persona haga nada.
//
// Nunca molesta: un fallo (de Notion o de la red) se ignora en silencio, sin avisos ni bucles (el servidor espera 15 minutos tras
// un fallo y el boton manual sigue existiendo). Sin Notion conectado, no hace nada. Solo se lanza UNA vez por visita.
const CADA_MS = 4000;
const MAX_VUELTAS = 45;   // ~3 minutos: si no acaba, se deja de preguntar (la proxima visita lo recoge)

export default function useNotionAlDia(notion, cargar, activo = true) {
  const lanzado = useRef(false);
  const antes = useRef(false);

  // 1. Pedirle al servidor que mire si toca (una vez, cuando se sabe que Notion esta conectado)
  const conectado = !!(notion && notion.conectado);
  useEffect(() => {
    if (!activo || !conectado || lanzado.current) return;
    lanzado.current = true;
    api.notionAlDia()
      .then(r => { if (r && r.lanzada) cargar(); })      // que la lista se entere de que ya esta sincronizando
      .catch(() => {});
  }, [activo, conectado, cargar]);

  // 2. Mientras sincroniza, volver a pedir la lista
  const sincronizando = !!(notion && notion.sincronizando);
  useEffect(() => {
    if (!sincronizando) return undefined;
    let vueltas = 0;
    const id = setInterval(() => {
      if (++vueltas > MAX_VUELTAS) { clearInterval(id); return; }
      cargar();
    }, CADA_MS);
    return () => clearInterval(id);
  }, [sincronizando, cargar]);

  // 3. Al terminar, una vez mas: la lista que acaba de salir pudo leerse justo antes de que acabase
  useEffect(() => {
    if (antes.current && !sincronizando) cargar();
    antes.current = sincronizando;
  }, [sincronizando, cargar]);
}
